export { default } from './ThankYou';
